import { useMutation } from "@tanstack/react-query";
import { ApiError, useApiClient } from "../../../apiClient";

export type GetAdminBookingCheckoutUrlResponse = {
    url: string | null;
    status: 'open' | 'complete' | 'expired';
};

type Params = {
    blockadeId: string;
    organizationId: string;
};

/**
 * On-demand fetch of the Stripe Checkout URL for a PENDING_PAYMENT
 * blockade. Modeled as a useMutation rather than useQuery because we only
 * want to round-trip Stripe when the operator actually clicks the
 * "Copy payment link" button — pre-fetching on modal mount would burn
 * Stripe API budget for every blockade the operator hovers.
 */
export const useGetAdminBookingCheckoutUrl = () => {
    const apiClient = useApiClient();
    return useMutation<GetAdminBookingCheckoutUrlResponse, ApiError, Params>({
        mutationKey: ['getAdminBookingCheckoutUrl'],
        mutationFn: ({ blockadeId, organizationId }: Params) =>
            apiClient.fetchApi<GetAdminBookingCheckoutUrlResponse, {}>({
                method: 'GET',
                endpoint: `payments/admin-bookings/${blockadeId}/checkout-url?organizationId=${encodeURIComponent(organizationId)}`,
            }),
    });
};
